import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import products from './modules/products';
import email from './modules/email';
import todo from './modules/todo';
// import firebase_todo from './modules/firebase_todo';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import { match_scoring } from './modules/match_scoring';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';

import personality from './modules/asessment/personality.js';
import communication from './modules/asessment/communication.js';
import leadership from './modules/asessment/leadership.js';
import socialInteraction from './modules/asessment/socialInteraction.js';
import thinkStyle from './modules/asessment/thinkStyle.js';
import jobPreference from './modules/asessment/jobPreference.js';
import survey from './modules/asessment/survey.js';
import numerical from './modules/asessment/numerical.js';
import intro from './modules/asessment/intro.js';
import notification from './modules/notification.js';
import { submitLogData } from '../_services/asessment.service';
import router from '../router';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
    },
    mutations: {
      changeLang (state, payload) {
        localStorage.setItem('currentLanguage', payload.id);
        localStorage.setItem('currentLanguageIcon', payload.icon);
        window.location.reload();
      },
      SET_SECTION(state, payload) {
        localStorage.setItem('last_section', payload)
          $axios.post(`start-assesment`,{
                  last_section : payload
          })
              .then((response) => {
                  resolve(response.data)
              })

          state.section.question = payload
      },
    },
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload);
      },
      submitAnswer({ commit }, payload) {
        return new Promise((resolve, reject) => {
          if(payload.is_finish){
            submitLogData(payload).then((res) => {
              router.push('/candidate/asessment');
            });
          }else{
            submitLogData(payload);
          }
        });
      },
    },
    modules: {
      alert,
      authentication,
      users,
      layout,
      chat,
      menu,
      products,
      email,
      todo,
      // firebase_todo,
      jobs,
      courses,
      common,
      match_scoring,
      personality,
      communication,
      leadership,
      socialInteraction,
      thinkStyle,
      numerical,
      jobPreference,
      survey,
      intro,
      notification
    }
});

